import { render, staticRenderFns } from "./StudentRegistrationAdmin.vue?vue&type=template&id=4970d259"
import script from "./StudentRegistrationAdmin.vue?vue&type=script&lang=js"
export * from "./StudentRegistrationAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports